import { render, staticRenderFns } from "./promiseGoodsReg.vue?vue&type=template&id=109a3588"
import script from "./promiseGoodsReg.vue?vue&type=script&lang=js"
export * from "./promiseGoodsReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports